export enum ProductDetailsTabs {
	DESCRIPTION = "Description",
	SPECIFICATION = "Specification",
	DELIVERY_AND_RETURNS = "Delivery and returns",
	SIZE_GUIDE = "Size guide",
	WASHING_INSTRUCTIONS = "Washing instructions",
	GPSR_INFORMATION = "GPSR Information",
	REVIEWS = "Reviews"
}

export enum ColorConfiguratorModes {
	DEFAULT = "default",
	IMAGE = "use-image"
}
